import { useNavigate } from "react-router-dom";

import useDisplay from "../../../hooks/useDisplay";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import styled from "styled-components";
import LSBdBody01 from "../../molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgBody01 from "../../molecules/text/linSeedKr/Rg/lsRgBody01";
import { route } from "../../../router/route";
import {
  formatNumberKM,
  formatNumberWithCommas,
} from "../../../util/formatNumber";

function CommunityItem({ style, data, categoryValue }) {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();

  return (
    <>
      <div
        onClick={() => {
          if (categoryValue > 0) {
            navigate(`${route.community_detail}/${data.id}`, {
              state: { categoryValue: categoryValue },
            });
          } else {
            navigate(`${route.community_detail}/${data.id}`);
          }
        }}
        style={{
          height: isMobile ? 96 : 64,
          borderTop: "1px solid #DBDDE0",
          display: "flex",
          flexDirection: "row",
          alignItems: isMobile ? "flex-start" : "center",
          padding: isMobile ? "16px 10px" : "0px 10px",
          cursor: "pointer",
          width: "100%",
          ...style,
        }}
      >
        <div
          style={{
            padding: isMobile ? "6px 12px" : "6px 14px",
            border: "1px solid #5050FF",
            borderRadius: 30,
            marginRight: 10,
          }}
        >
          <LSBdBody01
            style={{
              color: "#5050FF",
              fontSize: isMobile ? 10 : 14,
              lineHeight: isMobile ? "12px" : "19.6px",
            }}
          >
            {data.communityCategory?.title ?? "커뮤니티"}
          </LSBdBody01>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            flex: 1,
          }}
        >
          <ProductTitle
            $isMobile={isMobile}
            style={{
              fontSize: isMobile ? 14 : 18,
              lineHeight: isMobile ? "19.6px" : "25.2px",
              marginTop: isMobile ? 4 : 2,
              minHeight: isMobile ? 39.19 : "auto",
            }}
          >
            {data.title}
          </ProductTitle>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: isMobile ? 11 : 0,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                marginRight: isMobile ? 10 : 17,
              }}
            >
              <img
                style={{
                  width: isMobile ? 14 : 18,
                  height: isMobile ? 14 : 18,
                  objectFit: "cover",
                }}
                src={"/assets/icons/user.png"}
                alt={"작성자"}
              />
              <LSRgBody01
                style={{
                  color: "#898E99",
                  fontSize: isMobile ? 10 : 14,
                  lineHeight: isMobile ? "12px" : "19.6px",
                }}
              >
                {data.member?.nickname ?? "회원"}
              </LSRgBody01>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                marginRight: isMobile ? 10 : 17,
              }}
            >
              <img
                style={{
                  width: isMobile ? 14 : 18,
                  height: isMobile ? 14 : 18,
                  objectFit: "cover",
                }}
                src={"/assets/icons/view.png"}
                alt={"조회수"}
              />
              <LSRgBody01
                style={{
                  color: "#898E99",
                  fontSize: isMobile ? 10 : 14,
                  lineHeight: isMobile ? "12px" : "19.6px",
                }}
              >
                {formatNumberKM(data?.viewCount ? data?.viewCount : 0)}
              </LSRgBody01>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                marginRight: isMobile ? 0 : 17,
              }}
            >
              <img
                style={{
                  width: isMobile ? 14 : 18,
                  height: isMobile ? 14 : 18,
                  objectFit: "cover",
                }}
                src={"/assets/icons/comment.png"}
                alt={"댓글수"}
              />
              <LSRgBody01
                style={{
                  color: "#898E99",
                  fontSize: isMobile ? 10 : 14,
                  lineHeight: isMobile ? "12px" : "19.6px",
                }}
              >
                {formatNumberWithCommas(data.commentCount)}
              </LSRgBody01>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommunityItem;

const ProductTitle = styled(LSRgH2HeadLine)`
  flex: 1;
  color: #101113;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: ${(props) =>
    props.$isMobile ? "2" : "1"}; // 원하는 라인수
  -webkit-box-orient: vertical;
`;
